var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"mt-5"},[_vm._v("SQL Reporter")])])
}]

export { render, staticRenderFns }